import React, {useState} from 'react';
import {toast} from 'react-toastify';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import {LoadingButton} from '@mui/lab';
import {Card, Container, Typography} from '@mui/material';
import {request} from 'src/utils/AdminApi';
import {useNavigate} from 'react-router';
import {Link} from 'react-router-dom';

export default function ForgotPasswordPage() {
	const [email, setEmail] = useState('');
	const [isSubmitting, setIsSubmitting] = useState(false);
	const navigate = useNavigate();

	return (
		<Container maxWidth="xs">
			<Card sx={{p: 3, mt: 8}}>
				<form
					onSubmit={async (e) => {
						e.preventDefault();
						// Basic email format validation
						const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
						if (!email || !emailRegex.test(email)) {
							toast.error('يرجى إدخال بريد إلكتروني صحيح');
							return;
						}
						setIsSubmitting(true);

						try {
							await request('/auth/admin/forgot-password', 'POST', {email: email.trim()});
							toast.success('تم الإرسال إلى بريدك الإلكتروني');
							navigate('/reset-password');
						} catch (err) {
							const error_message = err?.response?.data?.message ?? err?.message ?? 'حدث خطأ غير متوقع';
							toast.error(error_message);
						} finally {
							setIsSubmitting(false);
						}
					}}
				>
					<Typography variant="h5" component="h1" gutterBottom>
						نسيت كلمة المرور؟
					</Typography>
					<Typography variant="body1" gutterBottom>
						أدخل بريدك الإلكتروني لكي يصلك رابط إعادة تعيين كلمة المرور
					</Typography>
					<div style={{display: 'flex', flexDirection: 'column', gap: 24, marginTop: 16}}>
						<TextField
							label="البريد الإلكتروني"
							variant="outlined"
							type="email"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							fullWidth
							disabled={isSubmitting}
							inputProps={{dir: 'ltr'}}
						/>
						<LoadingButton
							variant="contained"
							color="primary"
							type="submit"
							fullWidth
							disabled={!email}
							loading={isSubmitting}
						>
							{isSubmitting ? 'جاري الإرسال...' : 'إرسال'}
						</LoadingButton>
					</div>
				</form>
			</Card>
			<Link to="/login" passHref style={{textDecoration: 'none'}}>
				<Typography
					mt={2}
					sx={{cursor: 'pointer', color: 'white', textDecoration: 'none'}}
					textAlign="center"
				>
					عودة الي تسجيل الدخول
				</Typography>
			</Link>
		</Container>
	);
}
